import React from "react";
import Pagination from "rc-pagination";
import {locale} from "../../common/table/paginatorConfig";
import { SortIcons } from "components/SortIcons/SortIcons";
import { IPageResponse, SortDirection } from "common/interfaces/IPageResponse";
import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { CHARGING_REPORT_TYPE_MAP, ChargingReport, ChargingReportSortFields } from "./models";

interface ChargingReportsTableProps {
  reports?: IPageResponse<ChargingReport>;
  onPageChange: (page: number, size: number) => void;
  onSort: (sortField: ChargingReportSortFields) => void;
  sortField: ChargingReportSortFields;
  sortDirection: SortDirection;
  isRequesting: boolean;
  getFile: (chargingReportId: number) => void;
  loadingFileId?: number;
}

export function ChargingReportsTable(props: ChargingReportsTableProps) {
    const reports: Array<ChargingReport> = props.reports ? props.reports.content : [];
    const pageResponse = props.reports;

    const reportTableRows = reports.map((report) =>
        <tr key={'row-' + report.id}>
            <td className="text-nowrap">
                {report.id}<br />
            </td>
            <td className="line-height-1">
                {report.externalChargingStationId}<br />
            </td>
            <td className="text-nowrap">
                {report.chargingStationName}
            </td>
            <td className="text-nowrap">
                {report.dateIssued}
            </td>
            <td className="text-nowrap">
                {report.totalChargingQuantityKwh}
            </td>
            <td className="text-nowrap">
                {report.totalChargingAmountEuros}
            </td>
            <td className="text-nowrap">
                {CHARGING_REPORT_TYPE_MAP[report.type]}
            </td>
            <td>
                <div className="row__actions">
                    <OverlayTrigger delay={250}
                        overlay={
                            <Tooltip id={`charging-report-tooltip-${report.id}`}>
                                <p style={{margin: '3px'}}>Vaata raportit</p>
                            </Tooltip>} placement={"left"}>
                            <Button size="sm"
                                variant={'secondary'}
                                className="d-flex align-items-center justify-content-center btn-outline-icon ml-1" 
                                onClick={() => props.getFile(report.id)}
                            >
                                {
                                    props.loadingFileId === report.id ? (
                                        <Spinner size="sm" animation="border" />
                                    ) : (
                                        <div className='icon--16 icon__file action-icon'/>
                                    )
                                }
                            </Button>
                    </OverlayTrigger>
                </div>
            </td>
        </tr>
    );

    return (
        <table className='generic-table table table-responsive-md table-hover'>
            <thead>
            <tr>
                <th className="sort-down-up-hover">
                    <div className="d-flex align-items-center"
                        onClick={() => props.onSort(ChargingReportSortFields.ID)}>
                        <span>ID</span>
                        <SortIcons
                            sortedByField={props.sortField}
                            sortDirection={props.sortDirection}
                            currentSortColumn={ChargingReportSortFields.ID} />
                    </div>
                </th>
                <th className="sort-down-up-hover">
                    <div className="d-flex align-items-center"
                        onClick={() => props.onSort(ChargingReportSortFields.EXTERNAL_CHARGING_STATION_ID)}>
                        <span>Jaama noom id</span>
                        <SortIcons
                            sortedByField={props.sortField}
                            sortDirection={props.sortDirection}
                            currentSortColumn={ChargingReportSortFields.EXTERNAL_CHARGING_STATION_ID} />
                    </div>
                </th>
                <th>Jaama nimi</th>
                <th className="sort-down-up-hover">
                    <div className="d-flex align-items-center"
                        onClick={() => props.onSort(ChargingReportSortFields.DATE_ISSUED)}>
                        <span>Kuupäev</span>
                        <SortIcons
                            sortedByField={props.sortField}
                            sortDirection={props.sortDirection}
                            currentSortColumn={ChargingReportSortFields.DATE_ISSUED} />
                    </div>
                </th>
                <th>Kogus</th>
                <th>Summa KM-TA</th>
                <th className="sort-down-up-hover">
                    <div className="d-flex align-items-center"
                        onClick={() => props.onSort(ChargingReportSortFields.TYPE)}>
                        <span>Tüüp</span>
                        <SortIcons
                            sortedByField={props.sortField}
                            sortDirection={props.sortDirection}
                            currentSortColumn={ChargingReportSortFields.TYPE} />
                    </div>
                </th>
            </tr>
            </thead>
            <tbody>
                {
                    props.isRequesting ?
                    <tr>
                        <td colSpan={10} className="spinner-cell">
                            <div className="p-4 w-100 d-flex align-items-center justify-content-center">
                                <Spinner animation="grow" />
                            </div>
                        </td>
                    </tr> : reportTableRows
                }
            </tbody>
            {
                pageResponse ? (
                    <tfoot>
                        <tr>
                            <td colSpan={9}>
                                <div className="pagination-wrapper">
                                    <Pagination
                                        locale={locale}
                                        current={pageResponse.number + 1}
                                        total={pageResponse.totalElements}
                                        pageSize={pageResponse.size}
                                        prefixCls={"pagination"}
                                        onChange={props.onPageChange}
                                        showSizeChanger={false}
                                        hideOnSinglePage={true}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                ) : null
            }
        </table>
    )
}